import * as Tag from './tag';
import * as Type from './type';
import * as Prop from './prop';
import * as Event from './event';
import * as Breed from './breed';
import * as Support from './support';
export const Container = {
    models: {
        tag: Tag.Options,
        type: Type.Options,
        prop: Prop.Options,
        breed: Breed.Options,
        event: Event.Options,
        support: Support.Options
    }
};
